import { render, staticRenderFns } from "./OrderHistoryModal.vue?vue&type=template&id=27896914&scoped=true"
import script from "./OrderHistoryModal.vue?vue&type=script&lang=js"
export * from "./OrderHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryModal.vue?vue&type=style&index=0&id=27896914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27896914",
  null
  
)

export default component.exports